// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"c5037f97","83":"40adf4b3","133":"0603c86c","364":"6941d9b8","424":"18921797","502":"38863c33","648":"f4516a46","701":"26362751","829":"d9748bb0"}[chunkId] + ".chunk.css";
};